export enum ACTION_TYPE {
  SET_ERROR = "SET_ERROR",
  SET_VALUE = "SET_VALUE",
  SET_ERRORS = "SET_ERRORS",
  SET_VALUES = "SET_VALUES",
  RESET = "RESET",
}

export enum TARGET {
  ERROR = "ERROR",
  VALUE = "VALUE",
  ERRORS = "ERRORS",
  VALUES = "VALUES",
}

export type Manager<V> = {
  values: V;
  errors: {
    [K in keyof V]?: Error | undefined;
  };
  set: <T extends TARGET, K extends keyof V>(
    target: T,
    payload: T extends TARGET.ERROR
      ? [K, Error | undefined]
      : T extends TARGET.VALUE
      ? [K, V[K]]
      : T extends TARGET.ERRORS
      ? { [K in keyof V]?: Error | undefined }
      : T extends TARGET.VALUES
      ? Partial<V>
      : never
  ) => void;
  reset: () => void;
};

export type State<V> = {
  values: V;
  errors: {
    [K in keyof V]?: Error | undefined;
  };
};

type SetErrorAction<V, K extends keyof V> = {
  type: ACTION_TYPE.SET_ERROR;
  key: K;
  error: Error | undefined;
};

type SetValueAction<V, K extends keyof V> = {
  type: ACTION_TYPE.SET_VALUE;
  key: K;
  value: V[K];
};

type SetErrorsAction<V> = {
  type: ACTION_TYPE.SET_ERRORS;
  errors: { [K in keyof V]?: Error | undefined };
};

type SetValuesAction<V> = {
  type: ACTION_TYPE.SET_VALUES;
  values: Partial<V>;
};

type ResetAction = {
  type: ACTION_TYPE.RESET;
};

export type Actions<V> =
  | SetErrorAction<V, keyof V>
  | SetValueAction<V, keyof V>
  | SetErrorsAction<V>
  | SetValuesAction<V>
  | ResetAction;
